import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const AddV2 = (props: SvgIconT.Props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    paths={['M 16.5 9.5 H 10.5 V 3.5 H 9.5 V 9.5 H 3.5 V 10.5 H 9.5 V 16.5 H 10.5 V 10.5 H 16.5 Z']}
  />
);

export default AddV2;
